import slide1Src from './assets/onboarding-1.svg';
import slide2Src from './assets/onboarding-2.svg';
import { IOnboardingSlide } from '../../types';

export const ONBOARDING_SLIDES: IOnboardingSlide[] = [
  {
    src: slide1Src,
    title: 'Нужные данные уже есть',
    text: 'Знаем, сколько стоит ваша квартира, оценили доход от аренды, собрали ставки по банковским вкладам',
    hasNextButton: true,
  },
  {
    src: slide2Src,
    title: 'Мы всё посчитали',
    text: 'Отметили преимущества каждого варианта — можете выбрать подходящий сценарий',
    hasPrevButton: true,
    hasFinishButton: true,
  },
];
